import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import colors from "../../../../utils/colors";
import { AlertVendorCard, vendorMeta } from "./IntegrationsPage";

/** Alert destination vendors grouped by use case. Order is display order. */
export const ALERT_VENDOR_GROUPS = [
  {
    title: "On-call",
    kinds: ["pagerduty", "opsgenie", "victorops", "firehydrant"],
  },
  {
    title: "Ticketing",
    kinds: ["jira", "servicenow", "linear", "zendesk", "freshdesk"],
  },
  {
    title: "Chat",
    kinds: ["slack_app", "slack_webhook", "teams", "discord", "mattermost", "webex"],
  },
  {
    title: "Observability",
    kinds: ["datadog"],
  },
];

export function buildAlertVendorGroups(supportedKinds = []) {
  const byKind = Object.fromEntries(supportedKinds.map((k) => [k.kind, k]));
  const grouped = new Set();

  const groups = ALERT_VENDOR_GROUPS.map(({ title, kinds }) => {
    const items = kinds.map((kind) => byKind[kind]).filter(Boolean);
    items.forEach((k) => grouped.add(k.kind));
    return { title, kinds: items };
  }).filter((g) => g.kinds.length > 0);

  const other = supportedKinds.filter((k) => !grouped.has(k.kind));
  if (other.length > 0) {
    groups.push({ title: "Other", kinds: other });
  }

  return groups;
}

const gridSx = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
  gap: 3,
};

export function AlertVendorGroups({ supportedKinds, destinationsForKind, onOpenVendor }) {
  const groups = buildAlertVendorGroups(supportedKinds);
  if (!groups.length) return null;

  return (
    <Stack spacing={4} sx={{ mt: 4 }}>
      {groups.map((group) => (
        <Box key={group.title}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: colors.neutral[1000],
              mb: 2,
            }}
          >
            {group.title}
          </Typography>
          <Box sx={gridSx}>
            {group.kinds.map((k) => {
              const meta = vendorMeta(k.kind);
              const destinations = destinationsForKind(k.kind);
              const configured = destinations.length > 0;
              const enabled = destinations.some((d) => d.enabled);
              return (
                <AlertVendorCard
                  key={k.kind}
                  kind={k.kind}
                  displayName={meta.displayName}
                  configured={configured}
                  enabled={enabled}
                  onClick={() => onOpenVendor(k.kind)}
                />
              );
            })}
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
